const CONNECTION_ERROR = 'CONNECTION_ERROR';

const updateConnectionError = (state = {}, action) => {
    const { type = null, error = false } = action;
    if (type === CONNECTION_ERROR) {
        return {
            ...state,
            error
        };
    }

    return state;
};

export default updateConnectionError;
